import { Button } from "@aircall/ds";
import { AiAssist } from "@aircall/react-icons";
import { useTranslation } from "react-i18next";

import { ButtonLink } from "@/components/ButtonLink/ButtonLink";
import { FeatureBanner } from "@/components/FeatureBanner";
import { PlaygroundSectionLayout } from "../PlaygroundSectionLayout";
import { PlaygroundSubSectionLayout } from "../PlaygroundSubSectionLayout";
import { PlaygroundSubSectionTitle } from "../PlaygroundSubSectionTitle";

// The real AiPromotionalBanner is gated behind call transcription + license
// hooks, so it renders `null` outside a live call. This mirrors its
// visible-branch output to showcase the migrated icon and DS button in context.
function BannerActions() {
  const { t } = useTranslation();

  return (
    <div className="flex items-center gap-4">
      <Button variant="link" size="sm">
        {t("close")}
      </Button>
      <ButtonLink href="#" target="_blank" size="sm">
        {t("ai.banner.button")}
      </ButtonLink>
    </div>
  );
}

function BasicCase() {
  const { t } = useTranslation();

  return (
    <FeatureBanner fluid content={t("ai.banner.content")} icon={AiAssist}>
      <BannerActions />
    </FeatureBanner>
  );
}

function Vertical() {
  const { t } = useTranslation();

  return (
    <FeatureBanner
      fluid
      content={t("ai.banner.content")}
      icon={AiAssist}
      direction="vertical"
      alignItems="flex-start"
    >
      <BannerActions />
    </FeatureBanner>
  );
}

export function PlaygroundAiPromotionalBanner() {
  return (
    <PlaygroundSectionLayout>
      <PlaygroundSubSectionLayout>
        <PlaygroundSubSectionTitle>Basic Usage</PlaygroundSubSectionTitle>
        <BasicCase />
      </PlaygroundSubSectionLayout>

      <PlaygroundSubSectionLayout>
        <PlaygroundSubSectionTitle>
          Vertical direction
        </PlaygroundSubSectionTitle>
        <Vertical />
      </PlaygroundSubSectionLayout>
    </PlaygroundSectionLayout>
  );
}
